import React from "react";
import { Navigate } from "react-router-dom";
import { useContentSetting } from "../Hooks/ContentSetting";

// Mirrors RequireModule.jsx's shape, gating on the acting admin's own role
// instead of the school's module entitlements — for pages that are Owner/
// Manager only (e.g. Settings) rather than instructor-accessible.
export default function RequireRole({ roles, fallback = "/school/tutors", children }) {
  const { userInfo } = useContentSetting();
  if (!roles.includes(userInfo?.role)) {
    return <Navigate to={fallback} replace />;
  }
  return children;
}
